import { combineReducers } from 'redux'

const initialState = {
    togglePledgeDetail: false,
    toggleHowToBuy: false,
    toggleLicensePage: false
}
const global =  (state = initialState, action:any) => {
    switch (action.type) {
        case "setToggleHowToBuy":
            return {
                ...state,
                toggleHowToBuy: action.data
            }
        case "setTogglePledgeDetail":
            return {
                ...state,
                togglePledgeDetail: action.data
            }
        case "setLicensePage":
            return {
                ...state,
                toggleLicensePage: action.data
            }
         default:
            return state;
    }
}


export default combineReducers({
    global
})
